import { render, staticRenderFns } from "./CommissionBalances.vue?vue&type=template&id=b7e5eb32&scoped=true&"
import script from "./CommissionBalances.vue?vue&type=script&lang=js&"
export * from "./CommissionBalances.vue?vue&type=script&lang=js&"
import style0 from "./CommissionBalances.vue?vue&type=style&index=0&id=b7e5eb32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e5eb32",
  null
  
)

export default component.exports